import React, { useState } from 'react';
import {
  Application,
  ApplicationStatus,
} from '../../../../../../../../entities/Application';
import {
  AlertObject,
  AlertType,
} from '../../../../../../../../components/Alert';
import { ApplicationService } from '../../../../../../../../services/applicant_tracking/ApplicationService';
import { ConflictError } from '../../../../../../../../services/ApiService/errors/ConflictError';
import { BULK_REVIEW_NAVIGATION_TYPE } from '../../../../..';
import {
  MoveCandidateProps,
  MoveCandidateStageModal,
} from '../../../../../../../JobPage/components/MoveCandidateStageModal';
import { MoveDropdownButton } from './MoveDropdownButton';

interface PropTypes {
  application: Application;
  disabled: boolean;
  preSelectedStageId: number;
  onNext: (navType: BULK_REVIEW_NAVIGATION_TYPE) => void;
  onConflict: () => void;
  setAlert: (alert: AlertObject) => void;
  setPreSelectedStageId: (id: number) => void;
}

export function MoveApplication(props: PropTypes) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMoveError = (error: unknown, stageName?: string) => {
    if (error instanceof ConflictError) {
      props.setAlert({
        type: AlertType.Danger,
        message: <span className='fw-semibold'>{error.body?.message}</span>,
      });
      props.onConflict();
    } else {
      props.setAlert({
        type: AlertType.Danger,
        message: (
          <span className='fw-semibold'>
            Application could not be moved to{' '}
            {stageName ? <>the &quot;{stageName}&quot; stage</> : 'next stage'}.
          </span>
        ),
      });
    }
  };

  const moveToNextStage = async () => {
    try {
      await ApplicationService.moveStage(
        props.application.id,
        undefined,
        props.application.currentJobStageId,
      );
      props.setAlert({
        type: AlertType.Success,
        message: (
          <span className='fw-semibold'>
            Candidate was moved to the next stage!
          </span>
        ),
      });
      props.onNext('moved');
    } catch (error) {
      handleMoveError(error);
    }
  };

  const handleSpecificStageMoved = (action?: MoveCandidateProps) => {
    if (!action) return;
    setIsModalOpen(false);

    if (action.state === 'Error') {
      handleMoveError(action.error, action.jobStageName);
      return;
    }

    props.setPreSelectedStageId(
      action.rememberStage ? action.jobStageId : null,
    );
    props.setAlert({
      type: AlertType.Success,
      message: (
        <span className='fw-semibold'>
          Candidate was moved to the &quot;{action.jobStageName}&quot; stage!
        </span>
      ),
    });
    props.onNext('moved');
  };

  return (
    <>
      <MoveCandidateStageModal
        isOpen={isModalOpen}
        applicationId={props.application.id}
        candidateName={props.application.candidate?.name}
        currentStage={props.application.job_stage_name}
        currentStageId={props.application.currentJobStageId}
        jobId={String(props.application.job?.id)}
        preSelectedStageId={props.preSelectedStageId}
        showRememberCheckbox
        onClose={() => setIsModalOpen(false)}
        onMovingCandidate={handleSpecificStageMoved}
      />
      <MoveDropdownButton
        disabled={props.disabled}
        isLastStage={props.application.isLastStage}
        isHired={props.application.status === ApplicationStatus.Hired}
        isDropdownOpen={isDropdownOpen}
        onToggle={() => setIsDropdownOpen((prev) => !prev)}
        onMoveToNext={moveToNextStage}
        onMoveToSpecific={() => setIsModalOpen(true)}
      />
    </>
  );
}
